module.exports = __webpack_public_path__ + "media/images/sort-b774bd4880269ee66a0977b0805edff0.png";